import { render } from "./Noti_company.vue?vue&type=template&id=17c62f96&scoped=true"
import script from "./Noti_company.vue?vue&type=script&lang=js"
export * from "./Noti_company.vue?vue&type=script&lang=js"

import "./Noti_company.vue?vue&type=style&index=0&id=17c62f96&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c62f96"]])

export default __exports__